import { trackExperimentViewed as trackEV } from '@mc/track-event'
import { EXPERIMENT_FLAG } from '../constants'

/**
 * Fires Experiment Viewed for prcng-1079_v1.
 *
 * Called from the `onFirstVisible` of a `TrackingContainer` wrapping the FAQ
 * block on each surface, so exposure means "scrolled the FAQ into view" rather
 * than "expanded the cancel accordion item". `trackEV` early-returns for
 * unbucketed users, so no gating on the bucket is needed at the call site.
 */
export const trackExperimentViewed = () => {
  trackEV(EXPERIMENT_FLAG, {}, { trackUserLeap: true })
}
